module.exports = "/_next/static/images/30b85ea77071b52d4c3e81a2e849352e-hero.jpg.webp";